import { takeEvery } from 'redux-saga/effects';
import { handleApiRequest } from './handlers/handleApiRequest';
import { API_REQUEST } from './actions';

export default function* apiSaga(): Generator {
  yield takeEvery(API_REQUEST, handleApiRequest);
}
